import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import SessionCard from '../../components/ui/SessionCard';
import { fetchQuizSessions } from '../../services/quizSessionService';

function QuizResponsePage() {
    const { quiz_id } = useParams();  // Get the quiz_id from the URL params
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchResponses = async () => {
            try {                
                const data = await fetchQuizSessions(quiz_id);
                setSessions(data.results);
            } catch (err) {
                console.log(err);
                
                setError('Failed to load quiz responses');
            } finally {
                setLoading(false);
            }
        };

        fetchResponses();
    }, [quiz_id]);

    const quizTitle = sessions.length > 0 ? sessions[0].topic_detail?.title : '';

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <span className="loading loading-spinner text-primary w-12 h-12"></span>
            </div>
        );
    }
    if (error) return <div className='text-center text-red-600 mt-10'>{error}</div>;

    return (
        <div className="max-w-4xl p-4">
            <h1 className="text-4xl font-medium font-inter text-gray-800 mb-6">Quiz Responses</h1>
            {quizTitle && (
                <h2 className="text-lg text-gray-600 mb-6">
                    for <span className="font-semibold">{quizTitle}</span>
                </h2>
            )}

            {sessions.length === 0 ? (
                <div className="text-center py-8">
                    <div className="text-5xl mb-4">📝</div>
                    <h2 className="text-xl text-gray-600">No quiz responses yet</h2>
                </div>
            ) : (
                <div className="space-y-4">
                    {sessions.map((session) => (
                        <SessionCard key={session.id} session={session} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default QuizResponsePage;
